












































import { Vue, Prop, Watch, Component } from "vue-property-decorator";
import { Controlador as Model } from "../login-controlador";
import { Email } from '@/__env/ext';

@Component( {
    name: "Componente",
    props: {},
    components: {}
} )
export default class Componente extends Vue
{
    get Controlador() { return Model.Recuperar; }
    get UsuarioActual() { return Model.Recuperar.UsuarioActual; }

    Estado: 'cargando' | 'iniciado' = 'iniciado';
    MostrarPassword1: boolean = false;
    MostrarPassword2: boolean = false;
    Error: string = '';
    Password1: string = '';
    Password2: string = '';

    public async Comprobar()
    {


        if ( this.Password1.length < 3 )
        {
            document.getElementById( 'text-password' ).focus();
            this.Error = '¡Ingresá una contraseña válida!';
            return;
        }

        this.Estado = 'cargando';
        let response = await this.Controlador.Cambiar( this.Password1, this.Password2 );
        this.Password1= '';
        this.Password2= '';
        if ( response == "ok" )
        {
            //this.$router.push( this.Controlador.Redireccionar ? this.Controlador.Redireccionar : '/' );
        }
        else
        {
            document.getElementById( 'text-password' ).focus();
            if ( response == "datos-incorrectos" )
            {
                this.Error = '¡La contraseña no es correcta!';
            }
            else if ( response == "error" )
            {
                this.Error = 'Ocurrió un error en el servicio';
            }
        }
        this.Estado = 'iniciado';
    }

}
